import React, { Fragment, useContext, useEffect, useState } from "react";
import propTypes from "prop-types";
import { Button, Image } from "react-bootstrap";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import Layout from "components/sales/layout/layout";
import GSTDetails from "components/sales/formSection/GSTDetails/gstDetails";
// import ParkingRules from "components/sales/formSection/parkingRules/parkingRules";
import MaterialHardware from "components/sales/formSection/materialHardware/materialHardware";
import ShippedTo from "components/sales/formSection/shippedTo/shippedTo";
import BilledTo from "components/sales/formSection/billedTo/billedTo";
import ClientDetails from "components/sales/formSection/clientDetails/clientDetails";
import OtherDetailsApt from "components/sales/formSection/otherDetails/otherDetailsApt";
import GateDetails from "components/sales/formSection/gateDetails/gateDetailsApt";
// import DummyAdd from "components/sales/formSection/gateDetails/dummyAdd";
import Commercial from "components/sales/formSection/commercial/commercial";
import Installation from 'components/sales/formSection/commercial/installation';
import Milestone from 'components/sales/formSection/mileStone/mileStone';
import ModalPop from "components/sales/modal/modal";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import AgreementContract from "components/sales/formSection/agreementContract/agreementContract";
import Checkbox from "components/sales/Input/checkbox/checkbox";
import Tags from 'components/sales/formSection/materialHardware/tags';
import AdvancePayment from 'components/sales/formSection/materialHardware/advancePayment';
import Increament from 'components/sales/formSection/materialHardware/increament';
import InvoiceModule from 'components/sales/formSection/materialHardware/invoiceModule';


const PostSalesApartment = (props) => {
  const {
    history,
    postApartment,
    postApartmentData,
    pincodeData,
    locationPinCode,
    postSalesApartmentLead,
    documentUploadUrl,
    documentUrlData,
    match,
    getMaterial,
    getBrand,
    getMateriaById,
    getBrandById,
    imageUploadUrl,
    videoUploadUrl,
    supplyNameFun,
    splNameData,
    shipTolocationPinCode,
    shipToPincodeData,
    clientBillingPocData,
    clientBillingAddress
  } = props;
  const { params } = match;
  const postDataInputs = {
    commercial: null,
    gSTDetails: null,
    parkingRules: null,
    shippedTo: null,
    // billedTo: null,
    clientData: null,
    otherDetails: null,
    gateDetails: null,
    category: [],
    materialHardwares: null,
    gates: null,
    tags:[],
    installation: null,
    InvoiceModuleData:null,
  };

  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [showAgreementDetails, setShowAgreementDetails] = useState(false);
  const [agreementLength, setAgreementLength] = useState(null);
  const [isGateDetailsChanged, setIsGateDetailsChanged] = useState(false);
  // const [sameAsBillTo, setSameAsBillTo] = useState(null);


  const [postApartmentInputs, setPostApartmentData] = useState(postDataInputs);
  const handleCommercial = (val) => {
    setPostApartmentData({ ...postApartmentInputs, commercial: val });
    if (val?.totalContract) {
      setShowAgreementDetails(true);
      setAgreementLength(val?.totalContract);
      // console.log(val);
    }
  };
  const handleGstDetails = (val) => {
    setPostApartmentData({ ...postApartmentInputs, gSTDetails: val });
  };
  const handleParkingRules = (val) => {
    setPostApartmentData({ ...postApartmentInputs, parkingRules: val });
  };

  const handleGateDtl = (val) => {
    setPostApartmentData({ ...postApartmentInputs, gateDetails: val });
    setIsGateDetailsChanged(true);
  };
  const handleMileStone = (val) => {
    setPostApartmentData({ ...postApartmentInputs, milestone: val });
  };
  // const handleBillTo = (val) => {
  //   setPostApartmentData({ ...postApartmentInputs, billedTo: val });
  // };
  const handleShippedTo = (val) => {
    setPostApartmentData({ ...postApartmentInputs, shippedTo: val });
  };
  const handleClientData = (val) => {
    setPostApartmentData({ ...postApartmentInputs, clientData: val });
  };
  const handleOtherDetails = (val) => {
    setPostApartmentData({ ...postApartmentInputs, otherDetails: val });
  };
  const handleGatesData = (val) => {
    setPostApartmentData({ ...postApartmentInputs, categoryInventory: val });
  };
  const handleProductData = (val) => {
    setPostApartmentData({ ...postApartmentInputs, productInventory: val });
  };
  const handleMaterialhardware = (val) => {
    setPostApartmentData({ ...postApartmentInputs, materialHardwares: val });
  };
  const handleagreementDtls = (val) => {
    setPostApartmentData({ ...postApartmentInputs, agreementDtls: val });
  };
  const handleTags = (val) => {
    setPostApartmentData({ ...postApartmentInputs, tagsData: val });
  };
  const handleInstallation = (val) => {
    setPostApartmentData({ ...postApartmentInputs, installation: val });
  };
  const handlePayment = (val) => {
    setPostApartmentData({ ...postApartmentInputs, advPayment: val });
  };
  const handleIncreament = (val) => {
    setPostApartmentData({ ...postApartmentInputs, increamentData: val });
  };  
  const handleInvoiceAmt = (val) => {
    setPostApartmentData({ ...postApartmentInputs, InvoiceModuleData: val });
  }; 

  const handleModalHide = () => {
    history.push(`${baseUrl}/postSalesListing`);
    setIsModal(false);
  };

  const handleSubmit = (id) => {
    setIsClicked(true);
    const {
      commercial,
      gSTDetails,
      parkingRules,
      gateDetails,
      // billedTo,
      shippedTo,
      clientData,
      // otherDetails,
      categoryInventory,
      productInventory,
      materialHardwares,
      agreementDtls,
      advPayment,
      installation,
      increamentData,
      tagsData,
      InvoiceModuleData,
      milestone
    } = postApartmentInputs;
    // console.log(postApartmentInputs);
    if (
      (postApartmentData.leadStatus <= 4 && (
        commercial != null &&
        gSTDetails != null &&
        // billedTo != null &&
        shippedTo != null &&
        agreementDtls != null &&
        clientData != null
      ))
       ||
       (postApartmentData.leadStatus === 9 && (
        
        gateDetails != null &&
        // otherDetails != null &&
        gateDetails != null &&
        MaterialHardware != null &&
        materialHardwares != null 
      ))
      // parkingRules === null ||

    ) {
      setIsFiled(false);

      if(clientData != null && clientData.billing_address !== undefined){
        var fObj = {
          ...commercial,
          ...installation,
          ...gSTDetails,
          // ...parkingRules,
          // ...billedTo,
          ...shippedTo,
          // ...otherDetails,
          ...agreementDtls,
          clientData: clientData,
          gateDetails: gateDetails,
          isNewContract:0,
          leadStatus:postApartmentData.leadStatus,
          comm_id:postApartmentData.comm_id,
          materialHardwares: { ...materialHardwares },
          ...clientData.billing_address
        }; 
      }else{
        var fObj = {
          ...commercial,
          ...installation,
          ...gSTDetails,
          // ...parkingRules,
          // ...billedTo,
          ...shippedTo,
          // ...otherDetails,
          ...agreementDtls,
          clientData: clientData,
          gateDetails: gateDetails,
          isNewContract:0,
          leadStatus:postApartmentData.leadStatus,
          comm_id:postApartmentData.comm_id,
          materialHardwares: { ...materialHardwares },
          // ...clientData.billing_address
        }; 
      }

      if (categoryInventory !== null && categoryInventory !== undefined && productInventory !== null && productInventory !== undefined) {
        fObj.categoryInventory = [
          ...categoryInventory,
          ...productInventory?.productData,
        ];
      } else if (categoryInventory !== null && categoryInventory !== undefined) {
        fObj.categoryInventory = [
          ...categoryInventory,
        ];
      } else if (productInventory !== null && productInventory !== undefined) {
        fObj.categoryInventory = [
          ...productInventory?.productData,
        ];
      } else {
        fObj.categoryInventory = [];
      }
      
      if (tagsData !== null && tagsData !== undefined) {
        fObj.tags = [
          ...tagsData?.tagData,
        ];
      } else {
        fObj.tags = [];
      }
      if (advPayment !== null && advPayment !== undefined) {
        fObj.payment = [
          ...advPayment?.advData,
        ];
      } else {
        fObj.payment = [];
      }
      if (increamentData !== null && increamentData !== undefined) {
        fObj.increament = [
          increamentData,
        ];
      } else {
        fObj.increament = [];
      }
      if (milestone !== null && milestone != undefined) {
        let totalAmt = parseInt(postApartmentData?.commercialData?.total_mg_amount);
        let calculatedAmt = 0;
        if (!isNaN(totalAmt)) {
          if (totalAmt > 0) {
            for (let i = 0; i < postApartmentInputs.milestone?.milestone_data.length; i++) {
              if (postApartmentInputs.milestone.milestone_data[i].amt) {
                calculatedAmt += parseInt(postApartmentInputs.milestone.milestone_data[i].amt);
              }
            }
            for (let i = 0; i < postApartmentInputs.milestone?.date_invoices_data.length; i++) {
              if (postApartmentInputs.milestone.date_invoices_data[i].amt) {
                calculatedAmt += parseInt(postApartmentInputs.milestone.date_invoices_data[i].amt);
              }
            }
            for (let i = 0; i < postApartmentInputs.milestone?.retention.length; i++) {
              if (postApartmentInputs.milestone.retention[i].amt) {
                calculatedAmt += parseInt(postApartmentInputs.milestone.retention[i].amt);
              }
            }
            if (calculatedAmt > totalAmt) {
              toast.error('Milestone total amount is greater then capex amount!');
              setIsClicked(false);
              setIsFiled(true);
              return;
            } else {
              fObj.milestone=milestone;
            }
          }
        }
      }
      if(InvoiceModuleData !== null && InvoiceModuleData != undefined){
        let subsAmt = Number(postApartmentData?.commercialData?.subscription_amount);
        let invoiceAmt = InvoiceModuleData?.invoiceAmt;
        const initialValue = 0;
        const sumWithInitial = invoiceAmt.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          initialValue
        );
        console.log(sumWithInitial);
        if(subsAmt === sumWithInitial ){
          fObj.InvoiceModuleData=InvoiceModuleData;
        }else{
          toast.error('Total amount of invoice module is not equal to the total subscription amount!');
          setIsClicked(false);
          setIsFiled(true);
          return;
        }
       

      }
      // console.log(fObj); return false;
      (async () => {
        const res = await postSalesApartmentLead({ ...fObj, leadId: id });
        if (res) {
          setIsModal(true);
        }
      })();
      
    } else {
      setIsClicked(false);
      // console.log(commercial)
      // console.log(gSTDetails)
      // console.log(shippedTo)
      // console.log(agreementDtls)
      setIsFiled(true);
    }
  };

  useEffect(() => {
    (async () => await postApartment(params.lead_id))();
  }, [postApartment]);

  // console.log(postApartmentData); disabled={isClicked}

  const handleButtons = () => {
    return (
      <Fragment>
        <Button className="btn btn-transparent hidden">{localization.save}</Button>
        <Button onClick={() => handleSubmit(params.lead_id)} >
          {localization.submitDtl} <Image fluid src={Images?.ArrowRight} />
        </Button>
      </Fragment>
    );
  };
  function refreshPage() {
    window.location.reload(false);
  }

  return (
    <Layout
      history={history}
      Buttons={handleButtons}
      isGoback
      className={isFiled ? "requiredFileds" : ""}
      title={localization.addPost}
    >
      {postApartmentData.leadStatus <= 4 && (
        <>
      <Commercial
        is_fastag={1}
        data={postApartmentData}
        handleValue={handleCommercial}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
        supplyNameFun={supplyNameFun}
        splNameData={splNameData}
      />
      <AgreementContract
        isApartment={1}
        handleValue={handleagreementDtls}
        documentUploadUrl={documentUploadUrl}
        agreementLength={agreementLength}
        showDetails={showAgreementDetails}
      />
      <GSTDetails
        handleValue={handleGstDetails}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
      />
      {/*  <BilledTo
        handleValue={handleBillTo}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
      />
       <Checkbox
        label={"Same shipping address"}
        type="checkbox"
        errorMsg={localization.isRequired}
        onChange={(val) => {
          if (val) {
            setSameAsBillTo(postApartmentInputs.billedTo);
          } else {
            setSameAsBillTo({
              billPinCode: "",
              billGeoCity: "",
              billGeoState: "",
              billGeoCityId: "",
              billGeoStateId: "",
              billPinId: "",
              billAddressLine1: "",
              billAddressLine2: "",
            });
          }
        }}
      /> */}
      <ShippedTo
        handleValue={handleShippedTo}
        locationPinCode={shipTolocationPinCode}
        pincodeData={shipToPincodeData}
        leadData={postApartmentData.lead_name}
        // sameAsBillTo={sameAsBillTo}
      />
      <ClientDetails
        handleValue={handleClientData}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
        data={postApartmentData}
        clientBillingAddress={clientBillingAddress}
        clientBillingPocData={clientBillingPocData}
      />
      </>
      )}
      {/* <ParkingRules
        isApartment
        handleValue={handleParkingRules}
        data={postApartmentData}
      /> */}
      {postApartmentData.leadStatus === 9 && (
        <>
     
     
      <GateDetails
        handleValue={handleGateDtl}
        data={postApartmentData}
        imageUploadUrl={imageUploadUrl}
        videoUploadUrl={videoUploadUrl}
      />
       <MaterialHardware
        handleValue={handleMaterialhardware}
        data={postApartmentData}
        handleGatesData={handleGatesData}
        handleProductData={handleProductData}
        getMaterial={getMaterial}
        getMateriaById={getMateriaById}
        getBrandById={getBrandById}
        getBrand={getBrand}
      />
       <Tags
        handleValue={handleTags}
        data={postApartmentData} 
      />
        {postApartmentData.commercialData?.commercial_type_id === 7 && (
        <InvoiceModule
          handleValue={handleInvoiceAmt}
          data={postApartmentData} 
          prefilledData={postApartmentData?.postsale_data}
          invoiceAmtData = {postApartmentData?.postsale_data}
          isdisable={true}
        />
      )}
      {postApartmentData.commercialData?.commercial_type_id === 5 && (
          <Milestone
            handleValue={handleMileStone}
            totalAmount={postApartmentInputs.commercialData}
            gateData={postApartmentInputs?.gateDetails}
            gateDetailsChanged = {setIsGateDetailsChanged} 
            isGateDetailsChanged = {isGateDetailsChanged} 
          />
      )}
      {/* <DummyAdd
        handleValue={handleGateDtl}
        data={postApartmentData}
        imageUploadUrl={imageUploadUrl}
        videoUploadUrl={videoUploadUrl}
      /> */}
      <Installation
        isApartment={1}
        handleValue={handleInstallation}
      />

      <AdvancePayment
        handleValue={handlePayment}
        data={postApartmentData}
        imageUploadUrl={imageUploadUrl}
      />

      <Increament
        handleValue={handleIncreament}
        data={postApartmentData}
        imageUploadUrl={imageUploadUrl}
      />

      {/* <OtherDetailsApt
        isApartment
        handleValue={handleOtherDetails}
        data={postApartmentData}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
        imageUploadUrl={imageUploadUrl}
        videoUploadUrl={videoUploadUrl}
      /> */}
      </>
      )}
      {postApartmentData.leadStatus <= 4 && (
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadSuccess}</h5>
          <button onClick={refreshPage} className="btn btn-primary mb-4">
          {localization.saveAndNext} <img src={Images?.ArrowRight} alt="" />
          </button>
          {/* <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.postSales} <img src={Images?.ArrowRight} alt="" />
          </Link> */}
          {/* <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-transparent"
          >
            {localization.createAnother}
            <img src={Images?.arrowRightBlue} alt="" />
          </Link> */}
        </div>
      </ModalPop>
      )}
      {postApartmentData.leadStatus > 4 && (
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadSuccess}</h5>
          <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.postSales} <img src={Images?.ArrowRight} alt="" />
          </Link>
          {/* <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-transparent"
          >
            {localization.createAnother}
            <img src={Images?.arrowRightBlue} alt="" />
          </Link> */}
        </div>
      </ModalPop>
      )}


    </Layout>
  );
};

PostSalesApartment.propTypes = {
  history: propTypes.any,
};

export default PostSalesApartment;
